import { Appearance, PrintArea } from '@/types';
import { getPrintTypesOfAppearance } from '../productType/getPrintTypesOfAppearance';
import { getPrintTypesForPrintArea } from './getPrintTypesForPrintArea';

export const printTypesForDeliveryETA = (
  printArea: PrintArea | undefined,
  appearance: Appearance
) => {
  const printTypes = printArea
    ? getPrintTypesForPrintArea(printArea, appearance)
    : getPrintTypesOfAppearance(appearance);

  return printTypes.length ? [printTypes[0].id] : [];
};
